import React, { useContext } from "react";
import {
  BoldActiveIcon,
  BoldIcon,
  CodeActiveIcon,
  CodeIcon,
  ItalicActiveIcon,
  ItalicIcon,
  StrikeThroughActiveIcon,
  StrikeThroughIcon,
  SubScriptActiveIcon,
  SubScriptIcon,
  SuperScriptActiveIcon,
  SuperScriptIcon,
  UnderlineActiveIcon,
  UnderlineIcon,
} from "../../assets/ui-icons";
import { GrigoraFormatsContext } from "../formats";
import { Tooltip } from "../input";

const FormatOptionsInput = ({
  label,
  options = [
    {
      value: "bold",
      icon: <BoldIcon className="text-black" />,
      active: <BoldActiveIcon />,
      label: "Bold",
    },
    {
      value: "italic",
      icon: <ItalicIcon />,
      active: <ItalicActiveIcon />,
      label: "Italic",
    },
    {
      value: "underline",
      icon: <UnderlineIcon />,
      active: <UnderlineActiveIcon />,
      label: "Underline",
    },
    {
      value: "strikethrough",
      icon: <StrikeThroughIcon />,
      active: <StrikeThroughActiveIcon />,
      label: "Strike Through",
    },
    {
      value: "superscript",
      icon: <SuperScriptIcon />,
      active: <SuperScriptActiveIcon />,
      label: "Super Script",
    },
    {
      value: "subscript",
      icon: <SubScriptIcon />,
      active: <SubScriptActiveIcon />,
      label: "Sub Script",
    },
    {
      value: "code",
      icon: <CodeIcon />,
      active: <CodeActiveIcon />,
      label: "Code",
    },
  ],
}) => {
  const { activeFormats, applyFormat, removeFormat } =
    useContext(GrigoraFormatsContext) ?? {};

  return (
    <div className="text-grigora-base">
      <div className="text-ui-text-heading mb-2">{label}</div>
      <div className="editor-input-box flex justify-between bg-ui-light-white p-[3px] px-[14px] rounded-full ">
        {options.map((item) => {
          return (
            <Tooltip
              key={`formatting-${item.value}`}
              text={item.label}
              placement="top"
            >
              <div
                className={`cursor-pointer w-8 h-8 flex items-center duration-300 ${
                  activeFormats?.includes(item.value)
                    ? "!bg-ui-dark-blue"
                    : "bg-ui-light-white"
                } hover:bg-gray-200 rounded-full justify-center`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (activeFormats?.includes(item.value)) {
                    // remove format
                    removeFormat(item.value);
                  } else {
                    // apply format
                    applyFormat(item.value);
                  }
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                {activeFormats?.includes(item.value) ? item.active : item.icon}
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default FormatOptionsInput;
